import React, { FC } from 'react';
import styles from './index.module.scss';
import NotificationsItem from '../NotificationsItem';
import { useLoadNotifications } from 'src/models/notifications/hooks';

interface IProps {
  limit?: number;
  showMarkDown?: boolean;
  onClose?: () => void;
}

export const NotificationsList: FC<IProps> = props => {
  const { showMarkDown, onClose } = props;
  const { data } = useLoadNotifications();

  return (
    <ul data-name="notification-box" className={styles.notificationBox}>
      {data &&
        data.notifications.map(notification => (
          <NotificationsItem
            notification={notification}
            showMarkDown={showMarkDown}
            key={notification.createdAt}
            onClose={onClose}
          />
        ))}
    </ul>
  );
};

export default NotificationsList;
